export const LogEvent = [
  'addToTriage',
  'alreadyCanceled',
  'bulkAction',
  'canceledBySnap',
  'change',
  'claim reversal',
  'claim',
  'claimJumperError',
  'cmmCallback',
  'create',
  'dur',
  'eligibility check',
  'fill reversal',
  'internalTransfer',
  'inventory',
  'lot accuracy',
  'ndc manual entry',
  'note',
  'order return',
  'parataCancel',
  'parataComplete',
  'parataFill',
  'patientMatchDecision',
  'prepareToFulfillment',
  'prescriberPracticeChange',
  'print',
  'priorAuth',
  'rejectEscript',
  'remove',
  'removeFromTriage',
  'replacement',
  'scannedProductInfo',
  'scannedPackingMaterial',
  'sendToFulfillmentDelay',
  'sentToFulfillment',
  'shippingLabelRequest',
  'split',
  'surescriptsCancelRx',
  'surescriptsChangeRequest',
  'surescriptsChangeResponse',
  'surescriptsRenewalRequest',
  'surescriptsRxTransfer',
  'transfer',
  'updatedOrder',
  'updateOrderBySnapchat',
  'updateOTCProduct',
  'updateOTCProductsBySnapchat',
  'updatePackingMaterial',
  'verification',
  'view',
] as const

export type LogEvent = (typeof LogEvent)[number]
